// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".f-80 {\n  font-size: 80px; }\n\n.lighter {\n  font-family: 'Proxima Nova Lt';\n  font-weight: 300; }\n\n.semibold {\n  font-family: 'Proxima Nova Lt';\n  font-weight: 600; }\n\n.bold {\n  font-family: 'Proxima Nova Rg';\n  font-weight: bold; }\n\n.black {\n  font-family: 'Proxima Nova Bl';\n  font-weight: 900; }\n\n.regular {\n  font-family: 'Proxima Nova Rg';\n  font-weight: normal; }\n\n.copyRight {\n  font-size: 14px;\n  color: #999999; }\n", ""]);
// Exports
module.exports = exports;
